<template>
  <div class="add-employee-account">
    <!--show-error-icon-->
    <w-form ref="form" :model="formData" :rules="rules" label-width="110px" label-position="right">
      <w-formItem label="姓名" prop="name">
        <w-input v-model="formData.name" size="small" placeholder="示例：张明"></w-input>
      </w-formItem>
      <w-formItem label="账号" prop="account">
        <template slot="label">
          账号
          <el-tooltip class="item" effect="dark" placement="bottom-start" :offset="-7">
            <div slot="content" style="width: 260px; line-height: 24px;">
              员工唯一标识，可用于登录广联达产品，2-16位字符，以字母开头，建议使用组织内成员工号或姓名全拼，不填写则由系统自动生成，创建完成后无法修改
            </div>
            <i class="w-icon-wenhao color-default" style="font-size: 14px;vertical-align: baseline;"></i>
          </el-tooltip>
        </template>
        <w-input placeholder="请输入账号前缀"
                 name="account"
                 maxlength="16"
                 v-model.trim="formData.account"
                 size="small"
                 :disabled="isEditor">
          <template slot="append">@{{postfix}}</template>
        </w-input>
      </w-formItem>
      <w-formItem label="密码" prop="password" v-if="!isEditor" :style="{marginBottom: isValidatePass ? '35px' :''}">
        <template slot="label">
          密码
          <el-tooltip class="item" effect="dark" placement="bottom-start" :offset="-7">
            <!-- <div slot="content" style="width: 260px; line-height: 24px;">
              8-16位字符，由字母、数字和符号至少包含两种组成，不填写则由系统自动生成
            </div> -->
            <div slot="content" style="width: 260px; line-height: 24px;">
              8-16位字符，由大写字母、小写字母、数字、符号至少包含三种组成，不填写则由系统自动生成
            </div>
            <i class="w-icon-wenhao color-default" style="font-size: 14px;vertical-align: baseline;"></i>
          </el-tooltip>
        </template>
        <w-Input :type="password.type"
                 v-model.trim="formData.password"
                 name="member-pw" size="small"
                 :disabled="isEditor"
                 ref="password"
                 autocomplete="new-password"
                 placeholder="请输入密码">
          <i v-if="!isEditor" slot="suffix" class="cursor-pointer"
             :class="{'r2-icon-image_remove_red_eye_outlined': password.type === 'text', 'r2-icon-eye': password.type === 'password'}"
             @click="handlerToggle"></i>
        </w-Input>
      </w-formItem>
      <w-formItem label="手机" prop="passwordMobile">
        <div class="inline-block" style="width: 150px;">
          <w-input type="tel" v-model.trim="formData.passwordMobile" placeholder="请输入员工手机号" :maxlength="11"></w-input>
        </div>
        <div class="inline-block font-12 padding-left-10">手机将作为企业内联系的方式</div>
      </w-formItem>
      <w-formItem label="所属分组" prop="departmentId" style="overflow: hidden">
        <!-- <w-select v-model="formData.departmentId" placeholder="请选择所属分组" size="small" style="width: 342px;" @change="log('group', formData.departmentId)">
          <w-option
            style="width: 342px"
            v-for="(item, index) in [{departmentId: null, departmentName: '全公司'}, ...groupData]"
            :key="index"
            :label="item.departmentName"
            :value="item.departmentId">
          </w-option>
        </w-select> -->
        <w-cascader
        v-model="formData.departmentId"
          placeholder="请选择所属分组"
          :props="{value:'departmentId',label:'departmentName',children:'subList',emitPath:false,checkStrictly:true}"
          :show-all-levels="false"
          :options="[{departmentId: 'null', departmentName: '全公司',parentId:'null', subList: [...this.groupData]}]"
          filterable>
        </w-cascader>
      </w-formItem>
      <w-formItem prop="role" style="overflow: hidden">
        <template slot="label">
          岗位设置
          <!-- <i class="r2-icon-action_help_outline cursor-pointer color-999" style="font-size: 16px;" @click="showRoleDialog"></i> -->
        </template>
        <w-radio-group v-model="formData.role" @change="log('role', formData.role)">
          <w-radio :label="2">总负责人</w-radio>
          <w-radio :label="4">普通员工</w-radio>
        </w-radio-group>
        <div style="color: rgba(33, 37, 48, 0.8); fontSize:12px; lineHeight: 20px; marginTop: 10px;">
          总负责人具有企业最高管理权限；<br />
          普通员工，如需开放权限，可在表格中的权限列进行设置
        </div>
      </w-formItem>

    </w-form>
  </div>
</template>

<script>
import {isEmptyObject} from '@/assets/utils'

export default {
  name: 'home',
  props: {
    memberInfo: {
      type: Object,
      default: () => {
      }
    },
    postfix: {
      type: String,
      default: ''
    },
    isEditor: {
      type: Boolean,
      default: false
    },
    groupData: {
      type: Array,
      default: () => []
    },
    // 创建并继续添加  创建成功后 清空输入项
    resetInput: {
      type: Number,
      default: 0
    }
  },
  data () {
    const validateAccount = (rule, value, callback) => {
      // if (this.isEditor) {
      //   callback()
      // } else if (value === '') {
      //   return callback(new Error('不能为空！'))
      // } else if (!/^[0-9A-Za-z]+$/.test(value)) {
      //   return callback(new Error('由字母或数字组成'))
      // } else if (value.length + this.postfix.length > 31) {
      //   return callback(new Error(`长度不能超过${31 - this.postfix.length}个字符`))
      // } else {
      //   callback()
      // }
      if (this.isEditor || value === '') {
        callback()
      } else if (value && (!/^[A-Za-z][0-9A-Za-z\-_]+$/.test(value) || (value.length < 2 || value.length > 16))) {
        callback(new Error('2-16位字符，以字母开头，由字母、数字、_ 或 - 组成'))
      } else {
        callback()
      }
    }
    const validateGroup = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('不能为空！'))
      } else {
        callback()
      }
    }
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('不能为空！'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        return callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    // const validatePass = (rule, value, callback) => {
    //   if (this.isEditor || value === '') {
    //     callback()
    //   } else if (!/(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/.test(value)) {
    //     return callback(new Error('8-16位字符，由字母、数字和符号至少包含两种组成'))
    //   } else {
    //     callback()
    //   }
    // }
    const validatePass = (rule, value, callback) => {
      if (this.isEditor || value === '') {
        this.isValidatePass = false
        callback()
      } else if (!/^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*\d)|(?=.*[A-Z])(?=.*[a-z])(?=.*[~!.,@#$%^&*()_\-+=<>?:\\])|(?=.*[A-Z])(?=.*\d)(?=.*[~!.,@#$%^&*()_\-+=<>?:\\])|(?=.*[a-z])(?=.*\d)(?=.*[~!,.@#$%^&*()_\-+=<>?:\\]))[A-Za-z\d~!.,@#$%^&*()_\-+=<>?:\\]{8,16}$/.test(value)) {
        this.isValidatePass = true
        return callback(new Error('8-16位字符，由大写字母、小写字母、数字、符号至少包含三种组成'))
      } else {
        this.isValidatePass = false
        callback()
      }
    }
    return {
      formProps: {
        labelPosition: 'left',
        labelWidth: 110
      },
      password: {
        type: 'password'
      },
      formData: {
        name: '',
        account: '',
        password: '',
        passwordMobile: '',
        departmentId: null,
        role: 4
        // remark: ''
      },
      captchaId: 'f48c8384d76e43669e25f1f9f95ecbfc',
      rules: {
        name: [
          {required: true, message: '不能为空！', trigger: 'blur'},
          {max: 30, message: '长度不能超过30个字符', trigger: 'blur'}
        ],
        account: [
          // {required: true, message: '不能为空！', trigger: 'blur'}
          {validator: validateAccount, trigger: 'blur'}
        ],
        password: [
          {validator: validatePass, trigger: 'blur'}
        ],
        passwordMobile: [
          {required: true, validator: validateMobile, trigger: 'blur'}
        ],
        departmentId: [
          {required: true, validator: validateGroup, trigger: 'change'}
        ]
        // remark: [
        //   {max: 200, message: '长度不能超过200个字符', trigger: 'blur'}
        // ]
      },
      isValidatePass: false
    }
  },
  mounted () {
    if (!isEmptyObject(this.memberInfo)) {
      Object.assign(this.formData, this.memberInfo)
    }
    // setTimeout(() => {
    //   if (!this.isEditor) {
    //     this.password.type = 'password'
    //   }
    // }, 1000)
  },
  methods: {
    // 查看角色权限
    showRoleDialog () {
      !this.isEditor && this.sentLog(100117008)
      this.$emit('showRoleDialog', true)
    },
    // GA 埋点相关
    log (type, val) {
      /* GA 埋点 start */
      let message = ''
      switch (type) {
        case 'group':
          const groupList = [{departmentId: null, departmentName: '全公司', subList: [...this.groupData]}]
          groupList.forEach((item) => {
            if (item.departmentId === val) {
              message = item.departmentName
            }
          })
          if (!this.isEditor) {
            this.sentLog(100117006, {message})
          } else {
            this.sentLog(100117023, {message})
          }
          break
        case 'role':
          const fnCode = {
            2: 100117045,
            4: 100117046
          }
          if (this.isEditor) {
            fnCode[2] = 100117048
            fnCode[4] = 100117049
          }
          this.sentLog(fnCode[val])
          break
        default:
      }
      /* GA 埋点 end */
    },
    // 显示、隐藏密码
    handlerToggle () {
      if (this.password.type === 'text') {
        this.password.type = 'password'
      } else {
        this.password.type = 'text'
      }
    },
    // 提交
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$emit('closeMemberShow', this.formData)
        }
      })
    },
    // 关闭
    close () {
      this.$refs.form.resetFields()
      this.$emit('closeMemberShow', {})
    }
  },
  watch: {
    resetInput () {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="less">
  .w-cascader-node{
    .w__radio{
      margin-right: 0 !important;
    }
  }
  .add-employee-account {
    .btn {
      line-height: 1.499;
      position: relative;
      display: inline-block;
      font-weight: 400;
      white-space: nowrap;
      text-align: center;
      background-image: none;
      box-shadow: 0 2px 0 rgba(0, 0, 0, .015);
      cursor: pointer;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      touch-action: manipulation;
      height: 32px;
      padding: 0 15px;
      font-size: 14px;
      border-radius: 4px;
      color: rgba(0, 0, 0, .65);
      background-color: #fff;
      border: 1px solid #d9d9d9;

      &:active, &:focus {
        outline: 0;
      }

      &:hover {
        color: #40a9ff;
        border-color: #40a9ff;
        text-decoration: none;
        background: #fff;
      }

      &.btn-primary {
        color: #fff;
        background-color: #1890ff;
        border-color: #1890ff;
        text-shadow: 0 -1px 0 rgba(0, 0, 0, .12);
        box-shadow: 0 2px 0 rgba(0, 0, 0, .045);

        &:hover {
          color: #fff;
          background-color: #40a9ff;
          border-color: #40a9ff;
        }
      }
    }
    .w__input-group__append {
      color: #9f9f9f !important;
    }
  }
</style>
